import { EllipsisOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { FileDisplay } from '@web/react-common/src/components/file-display'
import { useRequest } from 'ahooks'
import { Button, Dropdown, Popconfirm, Spin, Typography } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { PpFile, Resource } from '@/schemas'

import { PpFileEdit } from './file-edit.component'

const CATEGORIES = ['PRD/需求文档', 'HLD/设计文档', '验收报告', '交付物', '其他']

interface FileListProps {
  pp: Resource
  map: any
  selfId: string
  loading: boolean
  canUpdate: boolean
  canDelete: boolean
  onSuccess: () => void
}

export const FileListContainer: React.FC<FileListProps> = ({
  pp,
  map,
  selfId,
  loading,
  canUpdate,
  canDelete,
  onSuccess,
}) => {
  const { t } = useTranslation()
  const [curFile, setCurFile] = useState<PpFile | null>(null)
  const { run: deletePpFile } = useRequest(
    (ppFileId) => ({
      url: '/api/project/deletePpFile',
      method: 'delete',
      params: {
        selfId,
        type: pp.type,
        ppFileId,
      },
    }),
    {
      manual: true,
      onSuccess: () => onSuccess(),
    }
  )

  const renderOss = (file: any) => <FileDisplay height='auto' width='100%' file={{ ...file }} showDownload />

  const OverlayMenu: React.FC<{ ppFile: PpFile }> = ({ ppFile }) => (
    <div className='flex flex-col'>
      <Popconfirm
        title={t('remove confirm')}
        okText={t('remove')}
        cancelText={t('cancel')}
        okButtonProps={{ danger: true }}
        icon={<QuestionCircleOutlined style={{ color: '#e11d48' }} />}
        onConfirm={() => {
          if (curFile) {
            deletePpFile(curFile.ppFileId)
          }
        }}
        disabled={!canDelete}
      >
        <Button type='text' danger disabled={!canDelete}>
          {t('remove')}
        </Button>
      </Popconfirm>
      <PpFileEdit ppFile={ppFile} canUpdate={canUpdate} onFinish={onSuccess} />
    </div>
  )

  return (
    <Spin spinning={loading} delay={300}>
      {/* t('PRD/需求文档'), t('HLD/设计文档'), t('验收报告'), t('交付物'), t('其他'), */}
      {map &&
        CATEGORIES.filter((c) => map[c]).map((category) => (
          <div key={category} className={'mt-20px'}>
            <div className='font-600 mb-20px text-16px'>{t(category)}</div>
            {map[category] &&
              map[category].map((ppFile: any) => (
                <div key={ppFile.id} className={'flex mb-10px justify-between card-body'}>
                  <Typography.Title
                    className={'w-200px flex-shrink-0 text-center card-body-title mt-10px'}
                    ellipsis={{ rows: 3, expandable: false }}
                    level={5}
                  >
                    {ppFile.file.title}
                  </Typography.Title>
                  <Typography.Paragraph
                    className={'pl-40px mt-10px border-left flex-grow'}
                    ellipsis={{ rows: 3, expandable: false }}
                  >
                    {ppFile.title || ppFile.description ? (
                      <>
                        <a href={ppFile.file.url} className='block' target='_blank' rel='noreferrer'>
                          {ppFile.title || ppFile.description}
                        </a>
                        {ppFile.description ? ppFile.description : ppFile.file.url}
                      </>
                    ) : ppFile.file.url.startsWith('https://agora-internal.oss') ? (
                      renderOss(ppFile.file)
                    ) : (
                      <a href={ppFile.file.url} className='block break-all' target='_blank' rel='noreferrer'>
                        {ppFile.file.url}
                      </a>
                    )}
                  </Typography.Paragraph>
                  <Dropdown forceRender={true} overlay={<OverlayMenu ppFile={ppFile} />} trigger={['click']}>
                    <Button
                      type='text'
                      className={'text-16px font-500 w-80px flex-shrink-0'}
                      onClick={(e) => {
                        setCurFile(ppFile)
                        e.preventDefault()
                      }}
                      icon={<EllipsisOutlined />}
                    ></Button>
                  </Dropdown>
                </div>
              ))}
          </div>
        ))}
    </Spin>
  )
}
